module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-11.b32a1290.jpg";